export enum AdditionalDataSectionConsts {
  VIN = 'vin'
}
